import React from "react";
import Link from "next/link";
import {
  FaqList,
  LandingSection,
  SectionHeader,
} from "./landing/landing-ui";

export const HOME_FAQS = [
  {
    question: "How long does a typical engagement take?",
    answer:
      "Discovery and a focused pilot often land in weeks. Production hardening depends on integrations and review requirements. We scope timelines against a clear outcome, not open-ended research.",
  },
  {
    question: "Do you replace our existing systems?",
    answer:
      "Usually no. We design AI to sit alongside ERP, CRM, and internal tools through APIs and controlled workflows so operators keep working in familiar places.",
  },
  {
    question: "What do you need from us to start?",
    answer:
      "A description of the workflow, who owns it, which systems and data are involved, and what success would look like in 60 to 90 days. Access for a pilot follows once scope is clear.",
  },
  {
    question: "How do you handle risk and governance?",
    answer:
      "We define human review points, evaluation criteria, and auditability up front. Tool access and data boundaries are part of design, not an afterthought.",
  },
];

function HomeFaq() {
  return (
    <LandingSection muted>
      <SectionHeader
        title="Common questions"
        lead="Straight answers about how we work with operations and engineering teams."
      />
      <FaqList items={HOME_FAQS} />
      <p className="mt-8 text-sm text-ink-muted">
        More detail on{" "}
        <Link href="/faq" className="font-semibold text-[#1c8c80] no-underline hover:underline">
          the FAQ page
        </Link>
        .
      </p>
    </LandingSection>
  );
}

export default HomeFaq;
